import React from 'react';
import {
  Button,
  Divider,
  IconButton,
  List,
  Menu,
} from 'react-native-paper';
import {
  encodeProject,
  genExecTime,
  recursiveShare,
} from '../../../api';
import {useAppDispatch, useAppSelector} from '../../../store/hooks';
import {
  addNewLogLine,
  setActiveLayer,
  setIsPlaying,
  setIsRendering,
  setRenderingError,
  setRenderProgress,
  setRenderUrl,
} from '../../../store/slices/editor';
import {Platform, useWindowDimensions} from 'react-native';
import {useShare} from '../../../hooks/useShare';
import {
  setFolderMenuItemId,
  setToastText,
} from '../../../store/slices/ui';
import {useMutation, useQueryClient} from 'react-query';

export function EditorPlayControls(props) {
  const {width} = useWindowDimensions();
  console.info('play controls props', props);
  const item = props.mediaRes;
  const dispatch = useAppDispatch();
  const caretPosition = useAppSelector(
    state => state.editor.caretPosition,
  );
  const scrollPosition = useAppSelector(
    state => state.editor.scrollPosition,
  );
  const pixelsPerSecond = useAppSelector(
    state => state.editor.pixelsPerSecond,
  );
  const isPlaying = useAppSelector(state => state.editor.isPlaying);
  const activeLayer = useAppSelector(
    state => state.editor.activeLayer,
  );
  const currentPosition =
    (caretPosition + scrollPosition) / pixelsPerSecond;
  const isRendering = useAppSelector(
    state => state.editor.isRendering,
  );
  const renderOutputURL = useAppSelector(
    state => state.editor.renderOutputURL,
  );
  const isMenuOpen =
    useAppSelector(state => state.ui.folderItemMenuOpen) === item?.id;
  const shareAllMedia = () => {
    dispatch(setFolderMenuItemId({itemId: undefined}));
    recursiveShare(item);
    dispatch(setToastText('All project files have been shared'));
    hideMenu();
  };
  const queryClient = useQueryClient();
  const {projectId} = props;
  const showMenu = () =>
    dispatch(setFolderMenuItemId({itemId: item.id}));
  const hideMenu = () =>
    dispatch(setFolderMenuItemId({itemId: undefined}));
  const {share} = useShare();
  const renderingMutation = useMutation(async () => {
    try {
      await queryClient.refetchQueries(
        ['folderData_' + projectId],
        {},
      );
      await queryClient.refetchQueries([
        'folderContent_' + projectId,
      ]);
      await queryClient.refetchQueries(['project_' + projectId]);
      await queryClient.refetchQueries(['projectLayers', projectId]);
      await queryClient.refetchQueries(['encodedMedia', projectId]);
      await queryClient.refetchQueries(projectId + '_comments');
      const render = await encodeProject(
        props.mediaRes,
        props.layers,
        false,
        renderParams => dispatch(setRenderProgress(renderParams)),
        logLine => dispatch(addNewLogLine(logLine)),
      );
      console.info('renderUrl', render);
      dispatch(setRenderUrl(render));
      dispatch(setIsRendering(false));
    } catch (err) {
      dispatch(setRenderingError(true));
    }
    hideMenu();
  });
  return (
    <List.Item
      style={{
        width: props.width || width,
        height: 70,
        position: 'absolute',
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex: 10000,
      }}
      left={p => <List.Icon {...p} icon={'clock'} />}
      title={genExecTime(currentPosition)}
      right={p => (
        <>
          <Button
            icon={'movie'}
            style={{
              pointerEvents: 'auto',
              cursor: 'pointer',
              height: 40,
            }}
            onPress={async () => {
              dispatch(setIsRendering(true));
              renderingMutation.mutateAsync();
              hideMenu();
            }}
            loading={isRendering}
            disabled={isRendering}
            mode={'outlined'}>
            {isRendering ? `Rendering` : 'Render'}
          </Button>
          <IconButton
            {...p}
            // size={fontSize}
            mode="contained"
            icon={!isPlaying ? 'play' : 'pause'}
            onPress={async () => {
              try {
                // console.info('toggle play', video3.current, video3.current?.playAsync)
                if (isPlaying === false) {
                  console.info('start play');
                  // dispatch(resetCurrentVideoStateToMain())
                  dispatch(
                    setActiveLayer({
                      activeLayerId: activeLayer,
                      caretPosition,
                      scrollPosition,
                    }),
                  );
                  dispatch(setIsPlaying(true));
                  // (video3.current as Video).shouldPlay = true
                } else {
                  // await (video3.current as Video).stopAsync()
                  dispatch(setIsPlaying(false));
                  // dispatch(resetCurrentVideoStateToMain())
                }
              } catch (err) {
                console.error(err);
              }
            }}
          />
        </>
      )}
    />
  );
}
